module.exports = __webpack_public_path__ + "static/media/tocso.9b91e15d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/tocso.jpg
// module id = 242
// module chunks = 0